import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    justifyContent: "space-between",
  },
  headerInfo: {
    flexDirection: "row",
    justifyContent: "space-between",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    fontSize: 18,
    color: "#077A97",
    marginBottom: '2%',
  },
  value: {
    textAlign: "center",
    fontSize: 28,
    color: "#077A97",
  },
  dateContainer: {
    alignItems: "center",
  },
  bold: {
    color: "#077A97",
    fontWeight: "bold",
    fontSize: 16,
    textTransform: "uppercase"
  },

  guiaContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly'
  },

  explanationText: {
    fontSize: 12,
    marginVertical: 16,
    flex: 1,
    maxWidth: '20%'
  },

  infoBottomContainer: {
    flexDirection: 'row',
    justifyContent: 'space-evenly'
  },

  explanationTextBottom: {
    fontSize: 12,
    marginVertical: 16,
    flex: 1,
    width: '100%',
  },

  qrCodeContainer: {
    alignItems: "center",
    marginVertical: 26,
  },
  codeHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  copyText: {
    color: "#256df4",
    fontSize: 16,
  },
  activityIndicatorContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },

  actionButton: {
    padding: 10,
    maxWidth: 320,
    height: 48,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
  },

  actionButtonText: {
    textTransform: "uppercase",
    letterSpacing: 1,
    color: "#fff",
  },

  pixCodeContainer: {
    flexDirection: 'row',
    padding: 6,
    justifyContent: 'center',
    borderWidth: 0.5,
    borderColor: '#077A97',
    borderRadius: 4,
    marginBottom: 12,
    flexWrap:'wrap'
  }
});
